import { emptyInventoryScope, normalizeInventoryScope } from '../../js/inventoryScope';

export default {
    BOOT(state, app) {
        state.accounts = app.accounts;
        state.categories = app.categories ? app.categories : [];
        state.displayCategories = state.categories
            .filter((category) => !category.hidden)
            .map((category) => ({ ...category, services: category.services.filter((service) => !service.hidden) }));
        state.securityGroups = app.securityGroups ? app.securityGroups : [];
        state.accessSecurityGroups = app.accessSecurityGroups ? app.accessSecurityGroups : [];
        state.requestPermissions = {
            export: app.requests?.export === true,
        };

        // Fail closed: отсутствие или неожиданная форма ответа означают «ничего нельзя»,
        // а не «можно всё». Раздел закрыт бэкендом в любом случае, но интерфейс не должен
        // показывать кнопки, которые заведомо вернут 403.
        const inventoryPermissions = app.inventory && app.inventory.permissions ? app.inventory.permissions : {};

        state.inventoryPermissions = {
            view: inventoryPermissions.view === true,
            edit: inventoryPermissions.edit === true,
            export: inventoryPermissions.export === true,
            manage: inventoryPermissions.manage === true,
        };

        // Область приходит другим запросом (/inventory/source-data), и её здесь нет.
        // Сбрасываем в закрытую: после новой загрузки приложения права могли измениться,
        // и область от прошлой сессии не должна пережить bootstrap. Раздел «Оборудование»
        // запрашивает справочники при открытии и проставит её заново.
        state.inventoryScope = emptyInventoryScope();

        state.services = state.categories.reduce((result, category) => {
            result.push(...category.services);

            return result;
        }, []);

        state.displayServices = state.displayCategories.reduce((result, category) => {
            result.push(...category.services);

            return result;
        }, []);
    },

    /**
     * Городская область раздела «Оборудование» из ответа /inventory/source-data.
     *
     * Нормализуется на входе, один раз: по компонентам расходится уже разобранный вид,
     * а не сырые ключи ответа. Неожиданная форма ответа закрывает доступ,
     * а не открывает — см. normalizeInventoryScope().
     */
    SET_INVENTORY_SCOPE(state, scope) {
        state.inventoryScope = normalizeInventoryScope(scope);
    },

    SET_REQUEST_STATUS(_, { request, status }) {
        request.status = status;
    },

    SET_ACTIVE_REQUEST(state, request) {
        state.activeRequest = request;
    },

    SET_REQUESTS_CONTEXT(state, requests) {
        state.activeRequests = requests;
    },

    UPDATE_REQUESTS_CONTEXT(state, requests) {
        requests.forEach((request) => {
            if (request.id === state.activeRequest?.id) {
                state.activeRequest = request;
            }

            const index = state.activeRequests.findIndex((item) => item.id === request.id);

            if (index !== -1) {
                state.activeRequests.splice(index, 1, request);
            } else {
                state.activeRequests.push(request);
            }
        });
    },

    ADD_REQUEST_OBSERVER(state, { request, observer }) {
        if (!Array.isArray(request.observers)) {
            request.observers = [];
        }

        request.observers.push(observer);
    },

    DELETE_REQUEST_OBSERVER(state, { request, observerId }) {
        const index = request.observers.findIndex((observer) => observer.id === observerId);

        if (index !== -1) {
            request.observers.splice(index, 1);
        }
    },

    UPDATE_REQUEST_IN_CONTEXT(state, request) {
        if (request.id === state.activeRequest?.id) {
            state.activeRequest = request;
        }

        const index = state.activeRequests.findIndex((item) => item.id === request.id);

        if (index !== -1) {
            state.activeRequests.splice(index, 1, request);
        }
    },

    UPDATE_SERVICE_SUPPORT_LEVEL(state, { serviceId, supportLevel }) {
        const updateService = (service) => {
            if (service && service.id === serviceId) {
                service.supportLevel = supportLevel;
            }
        };
        state.services.forEach(updateService);
        state.activeRequests.forEach((request) => updateService(request.service));
        if (state.activeRequest) {
            updateService(state.activeRequest.service);
        }
    },

    UPDATE_MENU_INFO(state, info) {
        state.menuInfo = info;
    },
};
